import script from "./CreateProperty.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateProperty.vue?vue&type=script&setup=true&lang=ts"

import "./CreateProperty.vue?vue&type=style&index=0&id=43647b28&lang=scss"

const __exports__ = script;

export default __exports__